import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchProgressionsByApprenant = createAsyncThunk(
  "progressions/fetchByApprenant",
  async (apprenantId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/progressions/apprenant/${apprenantId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur chargement");
    }
  }
);

export const marquerModuleTermine = createAsyncThunk(
  "progressions/marquerTermine",
  async ({ apprenantId, moduleId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.patch(`/progressions/terminer/${apprenantId}/${moduleId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur mise à jour");
    }
  }
);

const progressionSlice = createSlice({
  name: "progressions",
  initialState: { list: [], loading: false, error: null, success: null },
  reducers: {
    clearProgressionMessages: (state) => { state.error = null; state.success = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProgressionsByApprenant.pending,   (state) => { state.loading = true; })
      .addCase(fetchProgressionsByApprenant.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : (action.payload.data || []);
      })
      .addCase(fetchProgressionsByApprenant.rejected,  (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(marquerModuleTermine.fulfilled, (state, action) => {
        const idx = state.list.findIndex((p) => p._id === action.payload._id);
        if (idx !== -1) state.list[idx] = action.payload;
        else state.list.push(action.payload);
        state.success = "Module marqué comme terminé.";
      });
  },
});

export const { clearProgressionMessages } = progressionSlice.actions;
export default progressionSlice.reducer;
